import './Loader.css';

/**
 * Themed drop-in replacement for react-loader-spinner's default <Loader>.
 * Wired up via a webpack alias in config-overrides.js, so every existing
 * `import Loader from 'react-loader-spinner'` renders this instead.
 *
 * Renders a modern three-dot bouncing loader in the brand orange. It loops
 * every ~1.2s and scales responsively (capped against the viewport on small
 * screens). The legacy props (type/color/height/width/visible) are accepted
 * for compatibility; only size and visibility are honored.
 */
export default function Loader({ height, width, visible = true, className = '', style }) {
  if (visible === false) return null;

  const requested = Number(width) || Number(height) || 48;
  // Keep legacy sizes (e.g. height={200}) sensible without going tiny.
  const size = Math.min(Math.max(requested, 28), 72);

  return (
    <span
      className={`app-loader ${className}`.trim()}
      style={{ '--app-loader-size': `${size}px`, ...style }}
      role="status"
      aria-label="Loading"
    >
      <span className="app-loader-dot" />
      <span className="app-loader-dot" />
      <span className="app-loader-dot" />
    </span>
  );
}
